export const GET_TOP_RATED_MOVIES = "GET_TOP_RATED_MOVIES";
export const GET_SOME_OTHER_MOVIES = "GET_SOME_OTHER_MOVIES";
export const GET_LATEST_MOVIES = "GET_LATEST_MOVIES";
export const VERIFY_INITIAL_LIST_UPDATES_ARE_COMPLETE =
  "VERIFY_INITIAL_LIST_UPDATES_ARE_COMPLETE";
export const UPDATE_ACTIVE_BIG_INFO_KEY = "UPDATE_ACTIVE_BIG_INFO_KEY";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const TOGGLE_MODAL_FROM_SEARCH = 'TOGGLE_MODAL_FROM_SEARCH'

export const TOGGLE_GLOBAL_SCROLLBARS = "TOGGLE_GLOBAL_SCROLLBARS";

export const UPDATE_SEARCHED_MOVIE = "UPDATE_SEARCHED_MOVIE";